module.exports = __webpack_public_path__ + "static/gfycat-e6f6def7b0c084524d382d573270e0d8.png";